import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationLayoutComponent } from '../../layout/authentication-layout/authentication-layout.component';
import { DemoLayoutComponent } from '../../layout/demo-layout/demo-layout.component';
import { AdminLayoutComponent } from '../../layout/admin-layout/admin-layout.component';
import { Paths } from '../../enums';

const routes: Routes = [
  {
    path: Paths.authentication,
    component: AuthenticationLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: Paths.admin,
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./application/application.module').then(
        (m) => m.ApplicationModule
      ),
  },
  {
    path: Paths.demo,
    component: DemoLayoutComponent,
    loadChildren: () =>
      import('./demo/demo.module').then(
        (m) => m.DemoModule
      )
  },
  // {
  //   path: '',
  //   component: AuthenticationLayoutComponent,
  //   loadChildren: () =>
  //     import('./authentication/authentication.module').then(
  //       (m) => m.AuthenticationModule
  //     ),
  // }
  {
    path: '',
    component: AdminLayoutComponent,
    loadChildren: () =>
      import('./application/application.module').then(
        (m) => m.ApplicationModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminPanelRoutingModule { }
